/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { SimpleAction } from '../tool/action/simple-action';

export class GroupAction extends SimpleAction<SimpleAction<any>[]> {
  id: string;
  actions: SimpleAction<any>[];

  constructor(
    id: string,
    actions?: SimpleAction<any>[],
    align: 'left' | 'center' | 'right' = 'left'
  ) {
    super(id, null, actions, null);
    this.id = id;
    this.actions = actions || [];
    this.align = align;
  }

  /**
   * add action in a group action
   * @param action
   */
  addAction(action: SimpleAction<any>, index?: number) {
    if (index >= 0) {
      this.actions.splice(index, 0, action);
    } else {
      this.actions.push(action);
    }
  }

  /**
   * remove action in a group action
   * @param action
   */
  removeAction(action: SimpleAction<any>) {
    const actionIndex = this.actions.findIndex((a) => a.name === action.name);
    if (actionIndex >= 0) {
      this.actions.splice(actionIndex, 1);
    }
  }

  /**
   * remove action in a group action by index
   * @param action
   */
  removeActionByIndex(index: number) {
    if (index >= 0 && index < this.actions.length) {
      this.actions.splice(index, 1);
    }
  }
}
